export const getAccordionOverrides = () => {
  return {
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          margin: "16px 0 8px",
          "&.Mui-expanded": {
            margin: "8px 0"
          }
        }
      }
    }
  };
};